import { useSyncExternalStore } from 'react'

/**
 * Per-browser preference for the holdings table (John, Oct 30 2026): small
 * balances are hidden by default and the dollar line is his to set.
 */
export type HoldingsFilter = { hideSmall: boolean; minUsd: number }

const KEY = 'dispence.holdings-filter'
export const DEFAULT_HOLDINGS_FILTER: HoldingsFilter = { hideSmall: true, minUsd: 0.05 }

function read(): HoldingsFilter {
  try {
    const raw = window.localStorage.getItem(KEY)
    if (!raw) return DEFAULT_HOLDINGS_FILTER
    const parsed = JSON.parse(raw) as Partial<HoldingsFilter>
    const minUsd = Number(parsed.minUsd)
    return {
      hideSmall: parsed.hideSmall !== false,
      minUsd: Number.isFinite(minUsd) && minUsd >= 0 ? minUsd : DEFAULT_HOLDINGS_FILTER.minUsd,
    }
  } catch {
    return DEFAULT_HOLDINGS_FILTER
  }
}

let current = read()
const listeners = new Set<() => void>()

export function setHoldingsFilter(patch: Partial<HoldingsFilter>) {
  current = { ...current, ...patch }
  try {
    window.localStorage.setItem(KEY, JSON.stringify(current))
  } catch {
    // storage blocked: the choice lasts for this page
  }
  for (const listener of listeners) listener()
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function useHoldingsFilter() {
  return useSyncExternalStore(subscribe, () => current, () => DEFAULT_HOLDINGS_FILTER)
}
